module.exports = __webpack_public_path__ + ".well-known/img/apple-pay.54fca02c.png";